type Props = {
    section: string;
    onChange: (id: string) => void
}

export const IntroductionAdminSelector = ({ section, onChange }: Props) => {

    const introductionList = [
      { id: 'all', code: 'requests', name: 'Requests' },
      { id: 'pending', code: 'pending', name: 'Pending' },
      { id: 'rejected', code: 'rejected', name: 'Rejected' },
      { id: 'active', code: 'active', name: 'Active' },
    ]

    return (
        <div className="card">
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-bottom-0">
                {introductionList.map((item, index)=>(
                    <div className='d-flex flex-row' key={`tabs-experiences-${index}`}>
                        <li className="nav-item" style={{ cursor: 'pointer' }}>
                            <a className={`nav-link text-capitalize ${section === item.id ? "active" : ""}`}
                                onClick={() => onChange(item.id)}>
                                {item.name}
                                {/* <div className="badge-wrapper d-flex">
                                    <div className='badge-count'>2</div>
                                </div> */}
                            </a>
                        </li>
                        <li className={`separator-vertical ${index < introductionList.length-1 ? 'd-flex' : 'd-none'}`}>
                            <hr />
                        </li>
                    </div>
                ))}
            </ul>
        </div>
    )
}